"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFileUrlName = exports.getFileUrlExtension = exports.checkYoutubeUrl = exports.checkValidUrl = exports.flatConversationsRaw = exports.safeText = exports.sortedConversations = exports.formatDate = exports.formatTime = exports.isTwoWeeksOrMore = exports.isWithinAWeek = exports.isYesterday = exports.isToday = exports.capitalizeFirstLetters = exports.capitalizeFirstLetter = exports.sliceIntoChunks = exports.BREAKLINE_REGEX = void 0;
const moment_1 = __importDefault(require("moment"));
exports.BREAKLINE_REGEX = /(\r\n|\n|\r)/gm;
/**
 * E.g. 2*2 chunk out of flat array
 * @param arr
 * @param chunkSize
 * @returns
 */
const sliceIntoChunks = (arr, chunkSize) => {
    const res = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
        const chunk = arr.slice(i, i + chunkSize) || [];
        res.push(chunk);
    }
    return res;
};
exports.sliceIntoChunks = sliceIntoChunks;
/**
 *
 * @param word
 * @returns
 */
const capitalizeFirstLetter = (word) => {
    return word.charAt(0).toUpperCase() + word.slice(1);
};
exports.capitalizeFirstLetter = capitalizeFirstLetter;
const capitalizeFirstLetters = (sentence) => {
    return (sentence.split(' ')
        .map((word) => (word.split('').map((letter, index) => (index === 0 ? letter.toUpperCase() : letter.toLowerCase())).join())).join());
};
exports.capitalizeFirstLetters = capitalizeFirstLetters;
/**
 * Date Time utils
 */
const REFERENCE = (0, moment_1.default)(); // fixed just for testing, use moment();
const TODAY = REFERENCE.clone().startOf("day");
const YESTERDAY = REFERENCE.clone().subtract(1, "days").startOf("day");
const A_WEEK_OLD = REFERENCE.clone().subtract(7, "days").startOf("day");
const isToday = (momentDate) => {
    return momentDate.isSame(TODAY, "d");
};
exports.isToday = isToday;
const isYesterday = (momentDate) => {
    return momentDate.isSame(YESTERDAY, "d");
};
exports.isYesterday = isYesterday;
const isWithinAWeek = (momentDate) => {
    return momentDate.isAfter(A_WEEK_OLD);
};
exports.isWithinAWeek = isWithinAWeek;
const isTwoWeeksOrMore = (momentDate) => {
    return !(0, exports.isWithinAWeek)(momentDate);
};
exports.isTwoWeeksOrMore = isTwoWeeksOrMore;
const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes < 10 ? "0" : ""}${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
};
exports.formatTime = formatTime;
const formatDate = (date) => {
    // for current date return time
    if ((0, exports.isToday)((0, moment_1.default)(date))) {
        return (0, moment_1.default)(date).format("LT");
    }
    // for current date return time
    if ((0, exports.isYesterday)((0, moment_1.default)(date))) {
        return "Yesterday";
    }
    // for current date return "day" such as "Friday"
    if ((0, exports.isWithinAWeek)((0, moment_1.default)(date))) {
        return (0, moment_1.default)(date).format("dddd");
    }
    // date default
    return (0, moment_1.default)(date).format("MM/DD/YY");
};
exports.formatDate = formatDate;
const sortedConversations = (data) => {
    return data?.sort((a, b) => parseInt(a.id) - parseInt(b.id));
};
exports.sortedConversations = sortedConversations;
const safeText = (labelText) => {
    return labelText.replaceAll("*", "");
};
exports.safeText = safeText;
const flatConversationsRaw = (conversations) => {
    return conversations
        .flatMap((obj) => Object.values(obj)); // Flatten the array of objects
};
exports.flatConversationsRaw = flatConversationsRaw;
const checkValidUrl = (string) => {
    try {
        const url = new URL(string.startsWith('http') ? string : `https://${string}`);
        // Ensure the hostname contains at least one dot (.)
        return url.hostname.includes('.');
    }
    catch {
        return false;
    }
};
exports.checkValidUrl = checkValidUrl;
const checkYoutubeUrl = (url) => {
    const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/(watch\?v=|v\/|embed\/|.+\?v=)?([^&]{11})/;
    return youtubeRegex.test(url);
};
exports.checkYoutubeUrl = checkYoutubeUrl;
const getFileUrlExtension = (url) => {
    const EXTENSION_REGEX = /[^.]+$/;
    return url.match(EXTENSION_REGEX)?.[0];
};
exports.getFileUrlExtension = getFileUrlExtension;
const getFileUrlName = (url) => {
    const EXTENSION_REGEX = /[^/]+$/;
    return url.match(EXTENSION_REGEX)?.[0];
};
exports.getFileUrlName = getFileUrlName;
